<template>
  <div class="id-card-confirm">
    <Progress progress="22"></Progress>
    <p class="title">{{ $t('openAccount.t000061') }}</p>
    <div class="info-box">
      <p class="sub">{{ $t('openAccount.t000062') }}</p>
      <div class="ipt-box" :class="{error: isClickNext && !form.nationality_name, dis: [1,2, '1', '2'].includes(process_id)}">
        <div class="ipt-main">
          <div class="val-box" @click="checkCountryDialog">
            <span class="label" :class="{ placeholder: !form.nationality_name }"
              >{{ $t('openAccount.t000063') }}</span
            >
            <span class="val" v-if="form.nationality_name">{{
              form.nationality_name
            }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('openAccount.t000064') }}</p>
      </div>
<!--      大陆 香港 才有中文名-->
      <template v-if="process_id != 3">
        <div class="ipt-box" :class="{error: isClickNext && !form.real_name, focus: inputFocusId == 1}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label" v-if="inputFocusId == 1 || form.real_name">{{ $t('openAccount.t000065') }}</span>
              <Field
                class="val"
                v-model="form.real_name"
                :placeholder="inputFocusId == 1 ? '' : $t('openAccount.t000065')"
                :formatter="formatCn"
                @focus="inputFocus(1)"
                @blur="inputBlur"
              ></Field>
            </div>
          </div>
          <p class="error">{{ $t('openAccount.t000066') }}</p>
        </div>
      </template>
      <div class="ipt-box" :class="{error: (isClickNext && !form.english_name) || (form.english_name && hasCN(form.english_name)), focus: inputFocusId == 2}">
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 2 || form.english_name">{{ englishNameLabel }}</span>
            <Field
              class="val"
              v-model="form.english_name"
              :formatter="formatVal"
              :placeholder="inputFocusId == 2 ? '' : englishNameLabel"
              @focus="inputFocus(2)"
              @blur="inputBlur"
            ></Field>
          </div>
        </div>
        <p class="error" v-if="process_id != 3" style="display: block !important;">{{ $t('openInstitutionServices.g000029') }}</p>
        <p class="error" v-else>{{ $t('openAccount.t000068') }}</p>
      </div>
      <div class="ipt-box" :class="{error: isClickNext && !form.sex}">
        <div class="ipt-main" @click="showSexAction = true">
          <div class="val-box">
            <span class="label" :class="{ placeholder: !form.sex }"
              >{{ $t('openAccount.t000070') }}</span
            >
            <span class="val" v-if="form.sex">{{ form.sex == 1 ? $t('openAccount.t000071') : $t('openAccount.t000072') }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('openAccount.t000073') }}</p>
      </div>
      <div class="ipt-box" :class="{error: isClickNext && !form.birth}">
        <div class="ipt-main" @click="openDatePopup('birth')">
          <div class="val-box">
            <span class="label" :class="{ placeholder: !form.birth }"
              >{{ $t('openAccount.t000074') }}</span
            >
            <span class="val" v-if="form.birth">{{ form.birth }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('openAccount.t000075') }}</p>
      </div>
<!--      大陆+香港 或 其他类型有本地证件-->
      <template v-if="process_id != 3 || has_local_id == 1">
        <div class="ipt-box" :class="{error: (!form.id_card && isClickNext)  || (form.id_card && !checkIdCard(form.id_card)), focus: inputFocusId == 3}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label" v-if="inputFocusId == 3 || form.id_card">{{ $t('openAccount.t000076') }}</span>
              <Field
                class="val"
                v-model="form.id_card"
                :maxlength="process_id == 1 ? 18 : 15"
                :placeholder="inputFocusId == 3 ? '' : $t('openAccount.t000076')"
                @focus="inputFocus(3)"
                @blur="inputBlur"
              ></Field>
            </div>
          </div>
          <p v-if="process_id == 1 || has_local_id == 1" class="error ">{{$t('openAccount.t000077')}}</p>
<!--          <p v-if="process_id == 2" class="error right">{{$t('openAccount.t000078')}}</p>-->
        </div>
      </template>
<!--      大陆-->
      <template v-if="process_id == 1">
        <div class="ipt-box" :class="{error: isClickNext && !form.end_date}">
          <div class="ipt-main" @click="openDatePopup('start_date')">
            <div class="val-box">
            <span
              class="label"
              :class="{ placeholder: !(form.start_date && form.end_date) }"
            >{{$t('openAccount.t000079')}}</span
            >
              <span class="val" v-if="form.start_date && form.end_date"
              >{{ form.start_date }} {{$t('openAccount.t000080')}} {{ form.end_date }}</span
              >
            </div>
            <span class="icon-arrow"></span>
          </div>
          <p class="error">{{$t('openAccount.t000081')}}</p>
        </div>
        <div class="ipt-box" :class="{error: isClickNext && !form.province_name}">
          <div class="ipt-main">
            <div class="val-box" @click="openAreaPopup">
            <span class="label" :class="{ placeholder: !form.province_name }"
            >{{$t('openAccount.t000082')}}</span
            >
              <span class="val" v-if="form.province_name">{{ getFullAddress() }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
          <p class="error">{{$t('openAccount.t000083')}}</p>
        </div>
        <div class="ipt-box" :class="{error: isClickNext && !form.detail_address, focus: inputFocusId == 4}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label">{{$t('openAccount.t000084')}}</span>
              <Field
                class="val"
                v-model="form.detail_address"
                type="textarea"
                rows="2"
                :placeholder="inputFocusId == 4 ? '' : $t('openAccount.t000085')"
                @focus="inputFocus(4)"
                @blur="inputBlur"
              ></Field>
            </div>
          </div>
          <p class="error">{{$t('openAccount.t000086')}}</p>
        </div>
        <van-checkbox v-model="oneAddress" checked-color="#1677FF" shape="square">{{$t('openAccount.t000087')}}</van-checkbox>
      </template>
<!--      其他类型且无本地证件-->
      <template v-if="process_id == 3 && has_local_id == 0">
        <div class="ipt-box" :class="{error: isClickNext && !form.id_card, focus: inputFocusId == 5}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label" v-if="inputFocusId == 5 || form.id_card">{{$t('openAccount.t000088')}}</span>
              <Field
                class="val"
                v-model="form.id_card"
                :placeholder="inputFocusId == 5 ? '' : $t('openAccount.t000088')"
                @focus="inputFocus(5)"
                @blur="inputBlur"
              ></Field>
            </div>
          </div>
          <p class="error">{{$t('openAccount.t000089')}}</p>
        </div>
        <div class="ipt-box" :class="{error: isClickNext && !form.start_date}">
          <div class="ipt-main" @click="openDatePopup('start_date')">
            <div class="val-box">
            <span class="label" :class="{ placeholder: !form.start_date }"
            >{{$t('openAccount.t000090')}}</span
            >
              <span class="val" v-if="form.start_date">{{ form.start_date }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
          <p class="error">{{$t('openAccount.t000091')}}</p>
        </div>
        <div class="ipt-box" :class="{error: isClickNext && !form.end_date}">
          <div class="ipt-main" @click="openDatePopup('end_date')">
            <div class="val-box">
            <span class="label" :class="{ placeholder: !form.end_date }"
            >{{$t('openAccount.t000092')}}</span
            >
              <span class="val" v-if="form.end_date">{{ form.end_date }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
          <p class="error">{{$t('openAccount.t000093')}}</p>
        </div>
      </template>
      <NavButtons
        :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')"
        @on-next="next"
      />
    </div>
    <!--    选择国籍弹窗 -->
    <van-popup
      v-model="checkCountryNameDialog"
      :showConfirmButton="false"
      :class="bgColor == 'black-theme' ? 'darkOrLight' : 'check-country'"
      getContainer="body"
      position="right"
    >
      <div class="dialog-head">
        <a class="btn-back" @click="checkCountryNameDialogBack"></a>
        <p class="dialog-title">{{$t('openAccount.t000096')}}</p>
      </div>
      <div class="input-box">
        <Field
          v-model="checkCountryKeyWord"
          left-icon="search"
          :placeholder="$t('openAccount.t000097')"
        ></Field>
      </div>
      <div class="list">
        <div class="list-main">
          <template v-for="item in countryNameList">
            <div
              v-if="
                !checkCountryKeyWord ||
                  item.name.indexOf(checkCountryKeyWord) >= 0
              "
              @click="checkCountry(item)"
              class="item"
              :class="{ cur: form.country_code == item.id, dis: [1,2, '1', '2'].includes(item.id) }"
              :key="item.id"
            >
              <span>{{ item.name }}</span>
              <Icon
                v-show="form.country_code == item.id"
                name="success"
                color="#ff9275"
              />
            </div>
          </template>
        </div>
      </div>
    </van-popup>
    <!--    性别选择-->
    <ActionSheet
      :title="$t('openAccount.t000098')"
      v-model="showSexAction"
      :actions="sexActions"
      class="action-sheet-sex"
      @select="selectSex"
    ></ActionSheet>
    <!--    时间选择 出生日期 证件有效期 -->
    <van-popup
      v-model="showDatePopup"
      position="bottom"
      class="picker-popup picker-ui"
    >
      <p class="date-title">{{datePopupTitle}}</p>
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="datePopupConfirm"
        @cancel="showDatePopup = false"
      />
      <p class="end-date" v-if="showDatePopupKey == 'end_date'" @click="setEndDate">{{ $t('openAccount.t000173') }}</p>
    </van-popup>
<!--    地址选择 省市县 -->
    <van-popup v-model="showAreaPopup" position="bottom address-popup picker-ui">
      <van-area :value="form.country_code || form.city_code || form.province_code" :area-list="areaList" @cancel="showAreaPopup = false" @confirm="confirmArea"></van-area>
    </van-popup>
  </div>
</template>
<script>
import Progress from "@/views/open-account/components/Progress.vue";
import { ActionSheet, Area, Checkbox, CheckboxGroup, DatetimePicker, Field, Icon, Popup, Toast } from "vant";
import { formatDate } from "@/utils/date";
import NavButtons from "@/views/open-account/components/navButtons.vue";
import { isIdCard } from "@/utils/verify";
import moment from "moment";
import { dialogStatus } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";

export default {
  name: "IdCardConfirm",
  components: {
    NavButtons,
    Progress,
    Field,
    [Popup.name]: Popup,
    Icon,
    ActionSheet,
    [DatetimePicker.name]: DatetimePicker,
    [Area.name]: Area,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      process_id: '', // 1 大陆 2香港 3其他
      has_local_id: null, // 2-2 config_data 中获取，1有本地证件 0无本地证件
      oneAddress: true,
      form: {
        nationality_code: "",
        nationality_name: "",
        real_name: "",
        english_name: "",
        sex: "",
        birth: "",
        start_date: "",
        end_date: "",
        id_card: "",
        province_code: '',
        province_name: '',
        city_code: '',
        city_name: '',
        country_code: '',
        country_name: '',
        detail_address: ""
      },
      showSexAction: false, // 选择性别
      sexActions: [
        { name: this.$t('openAccount.t000071'), id: 1 },
        { name: this.$t('openAccount.t000072'), id: 2 }
      ],
      checkCountryNameDialog: false, // 选择国籍
      checkCountryKeyWord: "",  // 国籍搜索key
      countryNameList: [],
      showDatePopup: false, // 日期选择
      showDatePopupKey: '', // 当前选择日期的key  多个位置使用同一个组件的
      currentDate: "", // 当前已选日期
      showAreaPopup: false, // 省市县选择
      areaList: [],
      isClickNext: false,
      inputFocusId: null
    };
  },
  computed: {
    englishNameLabel() {
      const label = this.$t('openAccount.t000067');
      return this.process_id == 3 ? label.split('(')[0] : label;
    },
    minDate() {
      const date = new Date();
      const y = date.getFullYear() - 100;
      return new Date(y + "/" + "1/1");
    },
    maxDate() {
      const date = new Date();
      const y = date.getFullYear() + 100;
      return new Date(y + "/" + "1/1");
    },
    datePopupTitle() {
      const title = {
        'birth': this.$t('openAccount.t000099'),
        'start_date': this.$t('openAccount.t000100'),
        'end_date': this.$t('openAccount.t000101'),
      };
      return title[this.showDatePopupKey]
    },
    checkIdCard(){
      return (num) => {
        let res = !!num;
        if(this.process_id == 1){
          res = isIdCard(num);
        }
        else if(this.process_id == 2){
          res = /^[^\u4e00-\u9fff]{8,15}$/.test(num)
          
        }
        return res;
      }
    },
    hasCN(){
      return (str) => {
        const chineseRegex = /[\u4e00-\u9fa5]/; // 匹配中文字符的正则表达式
        return chineseRegex.test(str);
      }
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  mounted() {
    this.$JsBridge.registerHandler('closeDialog', () => {
      this.checkCountryNameDialog = false;
      dialogStatus({
        isShowing: false,
      })
    })
  },
  created() {
    this.getData();
  },
  methods: {
    inputFocus(id){
      this.inputFocusId = id;
    },
    inputBlur(){
      this.inputFocusId = null;
    },
    formatCn(e){
      return e.replace(/[^\u4e00-\u9fa5]/g, '')
    },
    formatVal(e){
      return e.replace(/[\u4e00-\u9fa5]/g, '');
    },
    isValidDate(dateStr) {
      return !isNaN(dateStr);
    },
    getData() {
      const loading = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text") 
      });
      this.$apis.accountSituationV2({
        step_code: "1,2-2,3-1,3-2",
      }).then(async (res) => {
        try {
          this.countryNameList = await this.$apis.getAllCountryList();
        }catch (e){

        }
        if (res?.process_info) {
          this.process_id = res?.process_info["1"]?.process_id || res?.get_open_account_info?.open_status;
          const configData22 = res?.process_info?.['2-2']?.config_data;
          if (configData22) {
            const parsed22 = JSON.parse(configData22);
            this.has_local_id = parsed22.has_local_id ?? null;
          }
          const config_data = res?.process_info?.['3-2']?.config_data;
          if(config_data){
            this.form = JSON.parse(config_data);
            const { birth, start_date, end_date } = this.form;
            this.oneAddress = this.form.oneAddress;
            this.form.birth = this.isValidDate(birth)
              ? moment(birth).format("YYYY-MM-DD")
              : birth;
            this.form.start_date = this.isValidDate(start_date)
              ? moment(start_date).format("YYYY-MM-DD")
              : start_date;
            this.form.end_date = this.isValidDate(end_date)
              ? moment(end_date).format("YYYY-MM-DD")
              : end_date;
          }

          if(this.process_id == 1 || this.process_id == 2 || this.process_id == 3){
            // 修改资料情况下不覆盖this.form
            if ( this.$route.query.change != 1 ) {
              this.form = JSON.parse(res.process_info?.['3-1']?.config_data)
            }else{
              const configData31 = JSON.parse(res.process_info?.['3-1']?.config_data);
              this.form.positive_img = configData31.positive_img;
              this.form.positive_img_base64 = configData31.positive_img_base64;
              this.form.inverse_img = configData31.inverse_img;
              this.form.inverse_img_base64 = configData31.inverse_img_base64;
            }
            if(this.process_id == 3){
              const { end_date } = this.form;
              this.form.end_date = this.isValidDate(end_date)
                ? moment(end_date).format("YYYY-MM-DD")
                : end_date;
            }
          }
          if(this.form.end_date == 'Invalid date'){
            this.form.end_date = ''
          }
          // 默认国籍  默认中国香港 ; 开户类型 == 香港, 则默认中国香港
          if(!this.form.nationality_code && this.countryNameList?.length > 0){
            let def = this.countryNameList.find(item => item.id == 1);
            // 香港 或者 其他 都默认 香港
            if(this.process_id == 2){
              def = this.countryNameList.find(item => item.id == 2);
            }else if(this.process_id == 3){
              def = {
                id: '',
                name: ''
              }
            }
            this.form.nationality_code = def.id;
            this.form.nationality_name = def.name;
          }
          if(this.form.nationality_code){
            this.form.nationality_name = this.countryNameList?.find(item => item.id == this.form.nationality_code)?.name;
          }
        }
      }).finally(() => {
        loading.clear();
      });
    },
    checkCountryNameDialogBack(){
      this.checkCountryNameDialog = false;
      if (getBrowser().isApp){
        dialogStatus({
          isShowing: false,
        })
      }
    },
    checkCountryDialog() {
      //  大陆 + 香港 不可选
      if([1,2, '1', '2'].includes(this.process_id)) return;
      this.checkCountryNameDialog = true;
      if (getBrowser().isApp){
        dialogStatus({
          isShowing: true,
        })
      }
    },
    checkCountry(e) {
      if (getBrowser().isApp){
        dialogStatus({
          isShowing: false,
        })
      }
      if([1,2, '1', '2'].includes(e.id)) return;
      this.form.nationality_code = e.id;
      this.form.nationality_name = e.name;
      this.checkCountryNameDialog = false;
    },
    selectSex(e) {
      
      this.form.sex = e.id;
      this.showSexAction = false;
    },
    // 日期选择
    openDatePopup(key) {
      this.showDatePopup = true;
      this.showDatePopupKey = key;
      const defaultDate = key === 'birth' ? '1990-01-01' : '2015-01-01';
      this.currentDate = new Date(this.form[key] || defaultDate);
    },
    // 日期选择确定
    datePopupConfirm() {
      this.showDatePopup = false;
      const { showDatePopupKey } = this;
      this.form[showDatePopupKey] = formatDate(this.currentDate, "yyyy-MM-dd");
      if (showDatePopupKey == "start_date") {
        // 大陆证件 有效期
        if(this.process_id == 1){
          this.$nextTick(() => {
            this.openDatePopup("end_date");
          });
        }
      }
    },
    setEndDate(){
      this.form.end_date = this.$t('openAccount.t000173')
      this.showDatePopup = false;
    },
    // 打开省市县选择
    openAreaPopup(){
      this.$apis.getAddressLists().then(res=>{
        const lang = localStorage.getItem('localLang');
        let key = 'en';
        if(lang != 'en'){
          key = 'zh';
        }
        this.areaList = res[key];
        this.showAreaPopup = true;
      })
    },
    confirmArea(e){
      this.form.province_code = e[0]?.code;
      this.form.province_name = e[0]?.name;
      this.form.city_code = e[1]?.code;
      this.form.city_name = e[1]?.name;
      this.form.country_code = e[2]?.code;
      this.form.country_name = e[2]?.name;
      this.showAreaPopup = false;
    },
    // 下一步
    next(){
      this.isClickNext = true;
      let requiredKey = []; // 不能为空的字段
      if(this.process_id == 1){
        requiredKey = ['nationality_code', 'nationality_name', 'real_name', 'english_name', 'sex', 'birth', 'start_date', 'end_date', 'id_card', 'province_code', 'province_name', 'detail_address']
      }
      else if(this.process_id == 2){
        requiredKey = ['nationality_code', 'nationality_name', 'real_name', 'english_name', 'sex', 'birth', 'id_card']
      }
      else if(this.process_id == 3){
        if(this.has_local_id == 1){
          requiredKey = ['nationality_code', 'nationality_name', 'english_name', 'sex', 'birth', 'id_card']
        } else {
          requiredKey = ['nationality_code', 'nationality_name', 'english_name', 'sex', 'birth', 'id_card', 'start_date', 'end_date']
        }
      }
      // 校验必填字段
      let check = true;
      for (let i = 0; i < requiredKey.length; i++){
        if(!this.form[requiredKey[i]]){
          check = false;
        }
      }
      // 不能为空 且id校验通过
      if(!check || !this.checkIdCard(this.form.id_card) || this.hasCN(this.form.english_name)) return;
      // 年龄判断
      const birthDate = new Date(this.form.birth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if(age < 18){
        Toast({
          message: this.$t('openAccount.t000102')
        });
        return;
      }
      const loading = Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      const params31 = {
        process_id: this.process_id,
        step_code: '3-1',
        step_order: 3,
        config_data: {
          ...this.form,
          oneAddress: this.oneAddress
        }
      }
      this.$apis.supplementSaveApi(params31)

      if(this.form.end_date == 'Invalid date'){
        this.form.end_date = ''
      }
      if(this.form.start_date == 'Invalid date'){
        this.form.start_date = ''
      }
      // 剔除inverse_img_base64字段（后端说传多余的会导致接口慢）
      const params = {
        process_id: this.process_id,
        step_code: '3-2',
        step_order: 3,
        config_data: {
          ...this.form,
          inverse_img_base64: '',
          card_term_start: this.form.start_date,
          card_term_end: this.form.end_date,
          oneAddress: this.process_id == 1 ? this.oneAddress : false,
          id_type: this.process_id == 3 ? (this.has_local_id == 1 ? 1 : 2) : 1
        },
        showLoading: true
      }
      this.$apis.supplementSaveApi(params).then((res) => {
        if(res.code && res.msg){
          this.$toast(res.msg)
          return
        }
        // 如果勾选了一致  直接跳过下一步 但是要提交数据
        if(this.process_id == 1 && this.oneAddress){

          const params_4 = {
            process_id: this.process_id,
            step_code: '4',
            step_order: 4,
            config_data: {
              ...this.form,
              inverse_img_base64: '',
              address_img: this.form.positive_img,
              address_img_base64: this.form.positive_img_base64,
              card_term_start: this.form.start_date,
              card_term_end: this.form.end_date,
              oneAddress: this.process_id == 1 ? this.oneAddress : false,
              id_type: this.process_id == 3 ? 2 : 1,
              nationality_or_region_code: this.form.nationality_code,
              nationality_or_region_name: this.form.nationality_name
            },
            showLoading: true
          };
          this.$apis.supplementSaveApi(params_4).then((res2) => {
            if (res2.code && res2.msg) {
              this.$toast(res2.msg)
              return
            }
            let path = '/open-account/personalInformation'
            if(this.$route.query.change == 1){
              path = "/open-account/home";
            }
            this.$router
              .push({
                path
              })
              .finally(() => {
                loading.clear();
              });
          })
        }else{
          let path = "/open-account/address-prove";
          if(this.$route.query.change == 1){
            path = "/open-account/home";
          }
          this.$router
            .push({
              path
            })
            .finally(() => {
              loading.clear();
            });
        }
      });
    },
    getFullAddress() {
      const { province_name, city_name, country_name } = this.form;
      return [province_name, city_name, country_name]
        .filter(name => name)
        .join("-");
    }
  }
};
</script>

<style scoped lang="less">
.id-card-confirm {
  padding-top: 62px;
  padding-bottom: 200px;
  color: #17161c;
  box-sizing: border-box;
  min-height: 100%;
  .title {
    color: #17161c;
    font-size: 36px;
    font-weight: 500;
    line-height: 88px;
    padding: 14px 32px 0;
    border-bottom: #f3f3f3 solid 1px;
  }
  .info-box {
    padding: 0 32px;
    .sub {
      margin: 32px 0;
      font-size: 28px;
    }
    .ipt-box {
      margin-bottom: 24px;
      &.dis {
        background: #F9FAFC;
        /deep/ .van-cell {
          background: #F9FAFC;
        }
        .val{
          color: #c8c9cc !important;
        }
        .icon-arrow{
          opacity: .4;
        }
      }
      &.focus{
        .ipt-main{
          &:after{
            border-color: #17161C;
          }
          ::v-deep .van-cell{
            input {
              &::placeholder {
                font-size: 0;
              }
            }
          }
        }
      }
      &.error{
        .ipt-main {
          &:after {
            border-color: #FD2626;
          }
        }
      }
      .ipt-main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 32px;
        min-height: 56px;
        position: relative;
        &:after{
          content: '';
          position: absolute;
          margin-top: -1px;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          border: 1px solid rgba(23, 22, 28, 0.25);
          transform: scale(0.5);
          border-radius: 20px;
        }
        .val-box {
          position: relative;
          z-index: 3;
          flex: 1;
          display: flex;
          flex-direction: column;
          line-height: 1;
          font-size: 32px;
          @keyframes labelAni{
            0%{
              font-size: 28px;
            }
            100%{
              font-size: 24px;
            }
          }
          .label {
            color: #747377;
            padding: 4px 0 20px;
            font-size: 24px;
            transform: translate3d(0,0,0);
            transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
            &.placeholder {
              padding: 12px 0 6px 0;
              font-size: 28px;
              animation: none;
            }
          }
          ::v-deep .van-cell {
            min-height: 0px;
            font-size: 32px;
            line-height: 32px;
            input{
              &::placeholder {
                font-size: 28px;
                color: #747377;
                font-weight: normal;
              }
              &:focus ~ .van-field__body{
                background: red;
              }
            }
            textarea {
              font-size: 32px;
              line-height: 35px;
              min-height: 70px;
              color: #17161c;
              &::placeholder {
                font-size: 28px;
              }
            }
          }
          .val {
            padding: 0;
            line-height: 36px;
            color: #17161c;
            font-weight: 500;
          }
        }
        .icon-arrow {
          width: 32px;
          height: 32px;
          background: url("../../../assets/images/arrow-down.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .error {
        display: none;
        margin-top: 12px;
        color: #fd2626;
        font-size: 24px;
        &.show{
          display: block;
        }
        &.right{
          text-align: right;
        }
      }
      &.error{
        .ipt-main{
          border-color: #fd2626;
        }
        .error{
          display: block;
        }
      }
    }
    ::v-deep .van-checkbox{
      margin-top: -5px;
      overflow: hidden;
      .van-checkbox__label{
        margin-top: 5px;
      }
      .van-icon-success{
        border-radius: 4px;
      }
    }
  }
}

.check-country {
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/arrow-right.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(180deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #17161c;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 75px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(23, 22, 28, 0.1);
        font-size: 28px;
        color: #323233;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
        &.dis{
          opacity: 0.5;
        }
      }
    }
  }
}
.action-sheet-sex{
  padding-top: 32px;
  .van-action-sheet__header{
    position: relative;
    .van-icon{
      font-size: 36px;
      color: #0F0F2F;
    }
  }
}
.picker-popup{
  padding-top: 32px;
  border-radius: 32px 32px 0 0;
}
.date-title{
  line-height: 96px;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
}
.end-date{
  z-index: 9;
  font-size: 32px;
  line-height: 1.17333rem;
  margin: 0 20px 20px;
  text-align: center;
  border-top: rgba(235,237,240,.4) solid 1px;
  border-bottom: rgba(235,237,240,.4) solid 1px;
}

.black-theme{
  .action-sheet-sex{
    .van-action-sheet__header{
      .van-icon{
        color: #fff;
      }
    }
  }
  .id-card-confirm{
    .title{
      color: #fff;
      border-color: rgba(50,52,66,.5);
    }
    .info-box{
      .sub{
        color: #fff;
      }
      .ipt-box{
        &.dis {
          background: #14151D;
          /deep/ .van-cell {
            background: #14151D;
          }
        }
        &.focus{
          .ipt-main{
            &:after{
              border-color: rgba(255,255,255,1);
            }
          }
        }
        &.error{
          .ipt-main{
            &:after{
              border-color: #fd2626;
            }
          }
        }
        .ipt-main{
          &:after{
            border-color: rgba(255,255,255,0.25);
          }
          .label{
            color: #9D9D9F;
          }
          .icon-arrow{
            background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
            width: 32px;
            height: 32px;
            background-size: 100% 100%;
          }
          .val{
            color: #fff;
            ::v-deep{
              .van-cell__value input::placeholder {
                color: #9D9D9F !important;
              }
              textarea{
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.darkOrLight{
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  background: #1B1C24;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/arrow-right.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(180deg);

      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(200%) contrast(100%);
      opacity: 1;
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 75px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 28px;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
      }
    }
  }
}
.address-popup{
  border-radius: 32px 32px 0 0;
  ::v-deep .van-picker{
    //border-radius: 32px 32px 0 0;
    .van-picker__toolbar{
      padding-top: 32px;
    }
    .van-picker__cancel {
      font-size: 32px;
    }
    .van-picker__confirm {
      font-size: 32px;
    }
  }
}
</style>
